"use strict";
// TODO: move to @hobt/constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanValidationErrorCode = void 0;
var LoanValidationErrorCode;
(function (LoanValidationErrorCode) {
    LoanValidationErrorCode["DuplicateDraftClaimErrorCode"] = "HBT_ERR_5003";
    LoanValidationErrorCode["ProcessInMicsClaimErrorCode"] = "HBT_ERR_5004";
    LoanValidationErrorCode["InvalidMlgLoanErrorCode"] = "HBT_ERR_5013";
    LoanValidationErrorCode["InvalidLoanNumberErrorCode"] = "HBT_ERR_5014";
    LoanValidationErrorCode["InvalidInsurancePolicyLoanErrorCode"] = "HBT_ERR_5015";
    LoanValidationErrorCode["InvalidRentalAndSocialHousingLoanErrorCode"] = "HBT_ERR_5016";
    LoanValidationErrorCode["InvalidLoanStatusErrorCode"] = "HBT_ERR_5017";
    LoanValidationErrorCode["InvalidPremiumsNotFullyPaidLoanErrorCode"] = "HBT_ERR_5018";
    LoanValidationErrorCode["CannotBeAcceptedAtLeastOneUnpaidClaimInProgressErrorCode"] = "HBT_ERR_5019";
    LoanValidationErrorCode["MainClaimPaidOrInProgressErrorCode"] = "HBT_ERR_5020";
    LoanValidationErrorCode["MainClaimDoesNotExistOrIsCurrentlyInProgressErrorCode"] = "HBT_ERR_5021";
    LoanValidationErrorCode["InvalidEnhancedAcppErrorCode"] = "HBT_ERR_5026";
    LoanValidationErrorCode["InvalidLegacyFinancialInstitutionErrorCode"] = "HBT_ERR_5029";
    LoanValidationErrorCode["InvalidLegacyLenderClaimProcessingTypeErrorCode"] = "HBT_ERR_5030";
    LoanValidationErrorCode["InvalidApprovedLenderErrorCode"] = "HBT_ERR_5031";
    LoanValidationErrorCode["InvalidMainClaimForSuppClaimErrorCode"] = "HBT_ERR_5032";
    LoanValidationErrorCode["LenderInformationMismatchErrorCode"] = "HBT_ERR_5038";
})(LoanValidationErrorCode = exports.LoanValidationErrorCode || (exports.LoanValidationErrorCode = {}));
